import(/* webpackMode: "eager" */ "/Users/gwrunner/actions-runner/GHA-3-M4B/_work/FBO/FBO/Procom.Phoenix.Web/Phoenix/microapps/t4-salaried-labour-burden-calculator/app/page.tsx");
